import { Injectable } from '@angular/core';

export interface PendingFavourite {
  action: 'favourite' | 'notify';
  registration: string;
  ts?: number;
}

/**
 * Persists a favourite/notify intent across a full-page social-login redirect
 * (e.g. Sign in with Apple), so it can be replayed once the user returns
 * signed in. In-modal logins (Google/Facebook/email) don't need this — they
 * resolve in place — so this is only set on the redirecting path.
 */
@Injectable({ providedIn: 'root' })
export class PendingFavouriteService {
  private readonly KEY = 'pla-pending-favourite';
  private readonly TTL_MS = 30 * 60 * 1000; // 30 minutes

  public set(pending: PendingFavourite): void {
    try {
      localStorage.setItem(
        this.KEY,
        JSON.stringify({ ...pending, ts: Date.now() })
      );
    } catch { /* storage unavailable — ignore */ }
  }

  public get(): PendingFavourite | null {
    try {
      const raw = localStorage.getItem(this.KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as PendingFavourite;
      if (!parsed || !parsed.registration) return null;
      if (parsed.ts && Date.now() - parsed.ts > this.TTL_MS) {
        this.clear();
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }

  public clear(): void {
    try { localStorage.removeItem(this.KEY); } catch { /* ignore */ }
  }
}
